


















	// @ts-ignore
    import _ from './MPopupWelcome.ts'; export default _;
